import { Box, Typography } from '@material-ui/core'

import { useStyles } from './styles'

const CULTURE_MAP = {
  cane: 'Cana-de-Açúcar',
  soybean: 'Soja',
}

const TREATMENT_MAP = {
  weed: 'Daninhas',
  planting_failure: 'Falha de Plantio',
}

interface TagProps {
  culture?: string
  treatment?: string
}

export function Tags({ culture, treatment }: TagProps) {
  const classes = useStyles()
  const cultureLabel = CULTURE_MAP[culture as keyof typeof CULTURE_MAP]

  const treatmentLabel = TREATMENT_MAP[treatment as keyof typeof TREATMENT_MAP]
  return (
    <Box display='flex' gridGap='1rem' className={classes.tag}>
      {culture && <Typography variant='subtitle2'>{cultureLabel}</Typography>}
      {treatment && (
        <Typography variant='subtitle2'>{treatmentLabel}</Typography>
      )}
    </Box>
  )
}
